
//export const STRIPE_PK_KEY = "pk_test_51O7gIAFbOrPEV0yNHVGOfc4QASOq1zDNygElO3kGZjYBu7Hr6rmWkzOJjBh2x7c4eKdxfFpvsZYVsh9MeSCS0eFQ00xn5Np3S0";
export const STRIPE_PK_KEY = "pk_live_51O7gIAFbOrPEV0yNeI8Qb7Zk4wfMJ14JCGxFT609YtEeb8H3IpHjP7zW9pM1kWX4Lc4nQA8b2FYph64sbzC1tO2t00Edq9eFHM";
